export interface Article {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  category: string;
  image: string;
  author: string;
  date: string;
  readTime: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    id: 'a1',
    title: '2024秋冬欧美时尚趋势：这五大元素你必须知道',
    slug: '2024-aw-fashion-trends',
    excerpt: '从米兰到巴黎，本季秋冬时装周展现了令人惊艳的设计理念。我们为你提炼了五大核心趋势，助你轻松掌握这一季的时尚密码。',
    content: `<p>随着2024秋冬时装周落下帷幕，欧洲顶级品牌纷纷展示了他们对新一季的独特理解。从经典的复刻到前卫的创新，本季呈现出了多元而丰富的时尚面貌。</p>
<h2>一、温暖大地色系的全面回归</h2>
<p>本季最显著的趋势莫过于大地色系的全面回归。从焦糖色、巧克力棕到橄榄绿，温暖而沉稳的色调成为了各大品牌的主旋律。Max Mara以其标志性的驼色大衣开场，而Bottega Veneta则将不同深浅的棕色进行层次叠搭，展现出令人惊艳的视觉效果。</p>
<p>对于追求品质的消费者来说，投资一件经典大地色单品，不仅能够轻松应对多季穿搭，更是欧美精品时尚品味的体现。</p>
<h2>二、 oversized 剪裁的持续火热</h2>
<p>宽松廓形依旧是本季的核心设计语言。不同于以往的随意慵懒，2024秋冬的oversized更强调结构感和比例控制。Balenciaga将夸张肩线与收腰设计相结合，创造出极具戏剧性的轮廓。</p>
<h2>三、皮革元素的全面渗透</h2>
<p>皮革不再是外套和包袋的专属，本季它渗透到了连衣裙、衬衫甚至针织品中。柔软的羊皮、细腻的小牛皮，以更加柔和的方式呈现，赋予皮革前所未有的优雅气质。</p>
<h2>四、复古印花的浪漫复兴</h2>
<p>来自英伦的 Liberty 风格碎花、法式的田园印花，在本季重新焕发生机。Dior将经典的花卉图案与现代剪裁相融合，打造出兼具复古韵味和当代感的成衣系列。</p>
<h2>五、可持续时尚的深度践行</h2>
<p>越来越多的欧美奢侈品牌将可持续发展作为核心战略。Stella McCartney继续以创新环保材料引领行业，而Gucci则推出了完整的可持续系列，将环保理念与高端品质完美结合。</p>
<p>在这个追求品质与责任并存的时代，选择真正用心打造的欧美精品，不仅是对自我的犒赏，更是对美好世界的支持。</p>`,
    category: '时尚服饰',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20fashion%20runway%20scene%20with%20models%20wearing%20warm%20earth%20tone%20outfits%2C%20luxury%20designer%20clothing%2C%20soft%20dramatic%20lighting%2C%20high-end%20fashion%20editorial%20photography%2C%20cream%20and%20brown%20color%20palette&width=800&height=500&seq=article-a1-01&orientation=landscape',
    author: '欧美精品时尚编辑',
    date: '2024-10-15',
    readTime: '8 分钟',
    tags: ['时尚趋势', '秋冬穿搭', '欧美品牌'],
  },
  {
    id: 'a2',
    title: '科学护肤指南：欧美顶级护肤品的正确使用顺序',
    slug: 'skincare-routine-guide',
    excerpt: '买了一堆高端护肤品却不知道怎么用？掌握欧美顶级护肤品牌推荐的正确使用顺序，让每一滴精华都物超所值。',
    content: `<p>面对琳琅满目的欧美精品护肤品，很多人会陷入选择的困惑——更重要的是，即使选对了产品，如果使用顺序不当，效果也会大打折扣。今天我们就来详细解析欧美护肤体系的标准流程。</p>
<h2>日间护肤黄金法则</h2>
<p>白天护肤的核心在于防护。清洁后的第一步永远是精华水/爽肤水，这一步能够平衡肌肤pH值，为后续吸收做好准备。接着使用抗氧化精华——这是欧美护肤体系中至关重要的一步。</p>
<p>推荐产品：Estée Lauder Advanced Night Repair（虽然名为夜间修护，但其抗氧化配方同样适合日间使用）或 Lancôme 小黑瓶精华。</p>
<p>精华之后是眼霜，用无名指轻轻点拍，避免拉扯脆弱的眼周肌肤。然后涂抹日霜/乳液锁住水分，最后——这一步绝对不能省略——涂抹足量的防晒霜。欧美顶级皮肤科医生一致认为，防晒是抗衰老的第一道防线。</p>
<h2>夜间修护完整流程</h2>
<p>夜间是肌肤修护的黄金时间。彻底卸妆和清洁后，同样的精华水步骤开启夜间护理。但夜间的精华选择可以更加"营养"——含有视黄醇（Retinol）、果酸（AHA）或胜肽的精华最适合在夜间使用。</p>
<p>需要注意的是，视黄醇类产品初期使用应从低浓度开始，每周使用2-3次，待肌肤建立耐受后再逐步增加频率。在这一步，La Roche-Posay的视黄醇精华是性价比极高的入门之选。</p>
<p>精华吸收后使用眼霜，然后上面霜。夜间面霜可以选择质地更加丰润的版本，为肌肤提供持续的滋养。</p>
<h2>周护理的必要步骤</h2>
<p>每周1-2次的深层清洁面膜和保湿面膜能够显著提升护肤效果。欧美顶级品牌如Glamglow的发光面膜和Fresh的红茶面膜都是口碑极佳的选择。</p>`,
    category: '护肤美妆',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20arrangement%20of%20luxury%20skincare%20products%20on%20marble%20vanity%2C%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20high-end%20beauty%20product%20flat%20lay%20photography%2C%20minimal%20composition&width=800&height=500&seq=article-a2-01&orientation=landscape',
    author: '欧美精品美容主编',
    date: '2024-10-10',
    readTime: '10 分钟',
    tags: ['科学护肤', '护肤品使用', '欧美品牌'],
  },
  {
    id: 'a3',
    title: '打造北欧风家居：从这些欧美精品家具开始',
    slug: 'nordic-home-decor-guide',
    excerpt: '北欧极简风为何风靡全球？从丹麦的经典设计到瑞典的现代美学，我们带你挑选最值得入手的欧美精品家居单品。',
    content: `<p>北欧设计以其简约、实用和永恒的美学，持续影响着全球家居潮流。来自丹麦、瑞典、芬兰的设计品牌，将功能主义与人文关怀融为一体，创造出经得起时间考验的经典之作。</p>
<h2>灯具：空间的灵魂</h2>
<p>在北欧漫长而黑暗的冬季，一盏好的灯具不仅仅是照明工具，更是生活的必需品。丹麦品牌Louis Poulsen的PH系列灯具，以其独特的层叠灯罩设计，能够将光线温柔地散射到空间的每个角落，创造出无眩光的舒适照明体验。</p>
<p>而瑞典的Iittala则以其精湛的玻璃工艺闻名，其设计的水晶吊灯将光影变幻演绎到了极致。</p>
<h2>家具：功能与美学的平衡</h2>
<p>提及北欧家具，不得不提丹麦的Hans J. Wegner。他的Y椅（Wishbone Chair）至今仍是全球最畅销的设计师椅子之一。简约的Y形靠背结构，配合手工编织的纸绳座面，将极简与工艺完美结合。</p>
<p>对于追求更大投资价值的消费者，Finn Juhl的酋长椅（Chieftain Chair）则是不二之选——这件被誉为"丹麦家具设计之父"的杰作，如今在拍卖市场上的价格持续攀升。</p>
<h2>软装：织物的温度</h2>
<p>北欧人对织物的热爱体现在方方面面。芬兰品牌Marimekko标志性的罂粟花图案，为空间注入勃勃生机。而挪威的Røros Tweed则坚持使用100%挪威羊毛，以传统织造工艺创造出温暖而耐用的毛毯和靠垫。</p>`,
    category: '生活家居',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Scandinavian%20minimal%20living%20room%20interior%20with%20warm%20wood%20furniture%20and%20designer%20lighting%2C%20cream%20walls%2C%20soft%20natural%20light%2C%20high-end%20interior%20design%20photography%2C%20cozy%20hygge%20atmosphere&width=800&height=500&seq=article-a3-01&orientation=landscape',
    author: '欧美精品家居编辑',
    date: '2024-09-28',
    readTime: '7 分钟',
    tags: ['北欧风', '家居设计', '欧美品牌'],
  },
  {
    id: 'a4',
    title: '欧美小众宝藏品牌大揭秘：拒绝撞款的品质之选',
    slug: 'hidden-gem-brands',
    excerpt: '厌倦了满大街的爆款？这些来自欧美的低调小众品牌，同样拥有令人惊艳的品质与设计，更懂你的独特品味。',
    content: `<p>在追求个性的时代，越来越多的时尚消费者开始将目光投向那些不为大众熟知的小众品牌。这些品牌往往以极致的工艺、独特的设计理念和限量生产的稀缺性，吸引着真正的品味人士。</p>
<h2>意大利：手工皮具的隐秘殿堂</h2>
<p>提到意大利皮具，大多数人想到的是Gucci和Prada，但真正懂行的人知道，在佛罗伦萨的小巷深处，隐藏着许多世代相传的手工皮具坊。Il Bisonte就是一个极好的例子——自1970年创立以来，始终坚持使用天然植鞣皮革，每一件产品都经过时间的沉淀后呈现出独特的色泽变化。</p>
<h2>法国：小众香氛的艺术表达</h2>
<p>法国香水品牌Diptyque虽然已不算严格意义上的小众，但其邻居Byredo（瑞典品牌，巴黎起家）更值得关注。每一款香氛都像是一篇叙事散文，从"无人区玫瑰"到"非洲之旅"，香气的层次感和故事性让人欲罢不能。</p>
<p>而对于更加挑剔的鼻子，Frédéric Malle的"出版社"模式则带来了更多惊喜——他邀请全球顶级调香师自由创作，每一瓶香水都是一件独立的艺术品。</p>
<h2>英国：Savile Row之外的绅士选择</h2>
<p>英伦绅士的形象深入人心，但并非人人都有时间飞往伦敦定制一套Savile Row西装。来自北安普顿的Crockett & Jones手工皮鞋，则提供了一个更加触手可及的选择。每一双鞋都经过200多道工序打造，Goodyear贴边工艺确保鞋底可以多次更换，真正实现"一双好鞋穿十年"。</p>`,
    category: '综合推荐',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20display%20of%20luxury%20artisan%20products%20including%20leather%20goods%20and%20fragrance%20bottles%20on%20wooden%20surface%2C%20warm%20cream%20background%2C%20soft%20natural%20lighting%2C%20high-end%20product%20photography%2C%20refined%20composition&width=800&height=500&seq=article-a4-01&orientation=landscape',
    author: '欧美精品特约编辑',
    date: '2024-09-20',
    readTime: '9 分钟',
    tags: ['小众品牌', '品质推荐', '欧美精品'],
  },
];

export function getArticleBySlug(slug: string): Article | undefined {
  return articles.find((a) => a.slug === slug);
}

export function getArticlesByCategory(category: string): Article[] {
  return articles.filter((a) => a.category === category);
}